import { Observable } from "rxjs/Observable"

import { getURLSearchParams, getAuthHeader } from "./utils/network-config"

export const getCommunityMemberList = (token, parameters) =>
    getCommunityParticipantList("member", parameters, token)
export const getCommunityManagerList = (token, parameters) =>
    getCommunityParticipantList("manager", parameters, token)
export const getCommunityFollowerList = (token, parameters) =>
    getCommunityParticipantList("follower", parameters, token)
export const getCommunityInvitedList = (token, parameters) =>
    getCommunityParticipantList("invited", parameters, token)
export const getCommunityAwaitingApprovalList = (token, parameters) =>
    getCommunityParticipantList("requested", parameters, token)

function getCommunityParticipantList(entityName, parameters, token) {
    const communityId = parameters.get("communityId")
    const headers = getAuthHeader(token)
    const urlParameters = getURLSearchParams(parameters.remove("communityId"))
    if (!communityId) {
        return Observable.of([])
    }
    return Observable.ajax.getJSON(
        `${
            process.env.REACT_APP_DASHBOARD_URI
        }/community/${communityId}/${entityName}?${urlParameters.toString()}`,
        headers
    )
}
